<template>
  <div class="footer-container">
    <img
      class="footer-back"
      :src="require('../../assets/imgs/icon/footer-back.png')"
      @click="this.onBack"
    />
    <div class="footer-content-container">
      <div
        class="item-container"
        @click="onItemClick(READING_FOOTER_TYPE.LEVEL)"
      >
        <div
          :class="
            active == READING_FOOTER_TYPE.LEVEL
              ? 'item-top-text-active'
              : 'item-top-text-inactive'
          "
        >
          {{ selectLevel.difficultyTitle }}>
        </div>
        <div
          :class="
            active == READING_FOOTER_TYPE.LEVEL
              ? 'item-bottom-active'
              : 'item-bottom-inactive'
          "
        >
          当前难度
        </div>
      </div>

      <footer-item
        :active="active == READING_FOOTER_TYPE.BACKGROUND_VIDEO"
        :text="'背景视频'"
        @click.native="onItemClick(READING_FOOTER_TYPE.BACKGROUND_VIDEO)"
        :activeIcon="
          require('../../assets/imgs/icon/footer-background-video-active.png')
        "
        :inactiveIcon="
          require('../../assets/imgs/icon/footer-background-video-inactive.png')
        "
      ></footer-item>
      <footer-item
        :active="active == READING_FOOTER_TYPE.NEW_WORD"
        :text="'生词本'"
        @click.native="onItemClick(READING_FOOTER_TYPE.NEW_WORD)"
        :activeIcon="
          require('../../assets/imgs/icon/footer-new-word-active.png')
        "
        :inactiveIcon="
          require('../../assets/imgs/icon/footer-new-word-inactive.png')
        "
      ></footer-item>

      <div class="home-button" @click="this.onButtonClick">{{ this.text }}</div>
    </div>
  </div>
</template>

<script>
import { READING_FOOTER_TYPE } from "../../contants/article";
import FooterItem from "./FooterItem";
import { mapState } from "vuex";

export default {
  name: "ReadingFooter",
  data() {
    return {
      READING_FOOTER_TYPE: READING_FOOTER_TYPE,
      FOOTER_ITEMS: [
        {
          label: "当前难度",
          type: READING_FOOTER_TYPE.LEVEL,
        },
        {
          label: "文章导读",
          type: READING_FOOTER_TYPE.BACKGROUND_VIDEO,
        },
        {
          label: "生词本",
          type: READING_FOOTER_TYPE.NEW_WORD,
        },
      ],
    };
  },
  components: {
    FooterItem,
  },
  computed: {
    ...mapState({
      contentId: (state) => state.article.contentId,
      levels: (state) => state.article.levels,
    }),
    selectLevel() {
      let level = _.filter(
        this.$store.state.article.levels,
        (item) => item.contentId == this.contentId
      );

      return level[0] || {};
    },
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    active: {
      type: Number,
      default: 0,
    },
    // selectLevel: {
    //   type: Object,
    //   default: () => {},
    // },
    onItemClick: {
      type: Function,
      default: () => {},
    },
    onButtonClick: {
      type: Function,
      default: () => {},
    },
  },
  activated() {
    console.log("++++>>>>", this.selectLevel);
  },
  methods: {
    onBack() {
      this.$router.back(-1);
    },
    // onButtonClick() {},
  },
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer-container {
  z-index: 5;
  position: fixed;
  bottom: 0;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  height: 62px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.footer-back {
  width: 62px;
  height: 62px;
}

.footer-content-container {
  display: flex;
  flex: 1;
  align-items: center;
  margin-left: 5px;
  justify-content: space-between;
}

.item-container {
  text-align: center;
  margin: auto 5px;
}

.item-top-text {
  &-active {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #3994E7;
  }

  &-inactive {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #333333;
  }
}

.item-bottom {
  &-inactive {
    color: #999999;
    margin-top : 4px
    line-height: 16px;
    font-size: 9px;
  }

  &-active {
    color: #3994E7;
    margin-top : 4px
    line-height: 16px;
    font-size: 9px;
  }
}

.item-top-icon {
  height: 18px;
}

.home-button {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  margin: 0 20px;
  // width: 100%;
  flex: 1;
  border-radius: 16px;
  background: linear-gradient(right, #98CEFF, #3994E7);
  background-color: orange;
}
</style>


// WEBPACK FOOTER //
// app/components/footer/ReadingFooter.vue